import { render, staticRenderFns } from "./export-google-forms-action.vue?vue&type=template&id=8fff256e&"
import script from "./export-google-forms-action.vue?vue&type=script&lang=js&"
export * from "./export-google-forms-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fff256e')) {
      api.createRecord('8fff256e', component.options)
    } else {
      api.reload('8fff256e', component.options)
    }
    module.hot.accept("./export-google-forms-action.vue?vue&type=template&id=8fff256e&", function () {
      api.rerender('8fff256e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/medical-analyses/components/export-google-forms-action.vue"
export default component.exports